import ClientPackagesList from './ClientPackagesList';
import ClientPackagesItem from './ClientPackagesItem';

export {
  ClientPackagesList,
  ClientPackagesItem,
};



// WEBPACK FOOTER //
// ./src/components/ClientPackages/index.js